import { gql } from '@apollo/client';

export const cancelJobMutation = gql`
  mutation cancelJob($id: Long!) {
    cancelJob(id: $id) {
      id
    }
  }
`;

export const createJobMutation = gql`
  mutation createExportJob(
    $projectId: Long!
    $organizationId: Long!
    $outputFormat: String!
    $dataTypeName: String!
    $startDateTime: String
    $endDateTime: String
    $omitFields: String
    $onlyFields: String
    $campaignId: Long
    $delimiter: String
  ) {
    createExportJob(
      projectId: $projectId
      organizationId: $organizationId
      outputFormat: $outputFormat
      dataTypeName: $dataTypeName
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      omitFields: $omitFields
      onlyFields: $onlyFields
      campaignId: $campaignId
      delimiter: $delimiter
    ) {
      id
    }
  }
`;
